














import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
import Footer from "@/components/footer/Footer.vue";
import VideoPlayer from "@/components/footer/VideoPlayer.vue";
import Header from "@/components/header/Header.vue";
import { DefineAbilityFor } from "@/config/ability";
import { CheckIsMUZE } from "@/helper/shareHelper";

const IsMUZE = CheckIsMUZE();
import { LoadingStatusType } from "@/enums/enums";
import { CreateIntercomHash } from "@/helper/intercomHelper";
import { ConvertToManageFinanceAndJournals, MerchantId, UserId } from "@/helper/userHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLoading = namespace("Loading");
const StoreLogIn = namespace("LogIn");
const StoreSetting = namespace("Setting");

@Component({
  components: {
    Header,
    Footer,
    VideoPlayer,
    Breadcrumb,
  },
})
export default class Layout extends Vue {
  private renderPage = false;
  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel | null;
  @StoreLogIn.Getter
  private getSetSelectMerchantLoadingStatus!: LoadingStatusType;
  @StoreSetting.Getter
  private getConnectPeakWithMerchantIdLoadingStatus!: LoadingStatusType;

  @StoreLogIn.Action
  private DoSelectMerchant!: (input: any) => void;
  @StoreLoading.Action
  private IsLoading!: (isLoading: boolean) => void;
  @StoreSetting.Action
  private DoGetConnectPeakWithMerchantId!: () => void;

  created() {
    const waitingForPEAK = document.getElementById("waitingForPEAK");
    if (waitingForPEAK) {
      waitingForPEAK.style.display = "none";
    }
  }

  mounted() {
    const userId = UserId();
    if (userId != 0 && !IsMUZE) {
      (this as any).$intercom.boot({
        /* eslint-disable @typescript-eslint/camelcase */
        user_id: userId,
        /* eslint-disable @typescript-eslint/camelcase */
        user_hash: CreateIntercomHash(userId),
      });
    }
  }

  @Watch("$route.query.emi", { immediate: true })
  queryEmiChange() {
    let urlEmi: any = this.$route.query.emi;
    let isUseMainDatabase = false;
    const query = Object.assign({}, this.$route.query);
    if (query.isumdb) {
      isUseMainDatabase = true;
      delete query.isumdb;
      this.$router.replace({ query });
    }
    urlEmi = urlEmi ? urlEmi.PeakDecryption() : null;
    if (urlEmi) {
      this.DoSelectMerchant({ merchantId: urlEmi, isUseMainDatabase: isUseMainDatabase });
    } else {
      this.$router.push({ name: "selectList" });
    }
  }

  @Watch("getSetSelectMerchantLoadingStatus")
  getSetSelectMerchantLoadingStatusChange(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      if (
        this.getMerchant &&
        this.getMerchant.merchantId 
      ) {
        const manageFinanceAndJournals =  ConvertToManageFinanceAndJournals(this.getMerchant.role.manageFinanceAndJournals);
        if(manageFinanceAndJournals.ChartofAccountAndGL.value)
        {
          if (this.getMerchant.merchantId !== MerchantId()) {
            sessionStorage.setItem("emi", this.getMerchant.merchantId.PeakEncryption());
          }
          if (!IsMUZE) {
          (this as any).$intercom.update({ company: { id: this.getMerchant.merchantId } });
        }
          const rules: any = DefineAbilityFor(this.getMerchant);
          this.$ability.update(rules);

          this.$nextTick(() => {
            this.DoGetConnectPeakWithMerchantId();
          });
        }
        else {
          this.$nextTick(() => {
            this.$router.push({ name: "canNotAccessMerchant" });
          });
        }
      } else {
        this.$nextTick(() => {
          this.$router.push({ name: "canNotAccessMerchant" });
        });
      }
    }
  }

  @Watch("getConnectPeakWithMerchantIdLoadingStatus", { immediate: true })
  getConnectPeakWithMerchantIdLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      this.renderPage = true;
    }
  }

  @Watch("$i18n.locale", { deep: true })
  localeChanged(newVal: any, oldVal: any) {
    if (newVal != oldVal) {
      this.IsLoading(true);
      this.$router.go(0);
    }
  }
}
